export default __webpack_public_path__ + "1cdb7af03d26265c5d2d6f094587b24d.svg";